// The site's version, a hash of its compiler, runtime, World Editor and
// examples' list (build.mjs). The IDE adds it to the address of each file it
// loads from the site, so that after a publish the browser fetches the new
// files rather than mixing them with old ones it kept: a new World Editor on
// an old runtime fails to start.
export const SITE_VERSION = typeof B3D_SITE_VERSION === "string" ? B3D_SITE_VERSION : "";

// A URL of the site's, with the site's version.
export const versioned = (url) => {
  const result = new URL(url, location.href);
  if (SITE_VERSION) result.searchParams.set("v", SITE_VERSION);
  return result.href;
};
